import * as React from "react";
import parse from "html-react-parser";
import * as sanitizeHtml from "sanitize-html";
import { Tooltip } from "primereact/tooltip";
import { cn, Component, I18NString } from "../../helpers/Utils";

interface Props {
	id: string;
	type: any;
	required: boolean;
	contentNumb: string;
	title: I18NString;
	status?: string;
	disabled?: boolean;
	disableNumber?: boolean;

	fullwidth?: boolean;
	bordered?: boolean;
	visible?: boolean;
	extra?: any;
	changed?: boolean;
	classNames?: string;
}

const MARGIN = {
	none: 0,
	low: 10,
	med: 25,
	high: 40,
};

class Field extends Component<Props, object> {
	private controlRef: any;

	// eslint-disable-next-line react/sort-comp
	constructor(props) {
		super(props);
		// @ts-ignore
		this.controlRef = React.createRef();
	}

	// eslint-disable-next-line react/static-property-placement
	static defaultProps = {
		status: "default",
		visible: true,
		disabled: false,
	};

	isStatus = (status: string): boolean => !this.props?.disabled && this.props.status === status;

	render() {
		const { id, required, title, contentNumb, disableNumber, visible, changed, bordered, extra, classNames, type } =
			this.props;
		const style = extra?.style || {};

		return (
			<div
				id={id}
				className={cn(
					`form-group ${classNames}`,
					{
						"control--changed": changed,
						"has-error": this.isStatus("error"),
						"has-success": this.isStatus("success"),
						"table-grid": type?.toUpperCase() === "GRIDEDITABLE",
					},
				)}
				hidden={!visible}
				style={{
					...style,
					marginTop: MARGIN?.[extra?.topMargin] ?? MARGIN.low,
					marginBottom: MARGIN?.[extra?.bottomMargin] ?? MARGIN.med,
					position: "relative",
				}}
			>
				<div
					className={cn("col-xs-12 fullwidth", {
						"label--bordered": bordered,
					})}
				>
					<label className="control-label">
						<div className="reportbox-content-num">{!disableNumber && contentNumb}</div>
						{title && (
							<div className={cn("reportbox-content-desc", { required })}>
								{extra?.tooltip && (
									// @ts-ignore
									// TODO !!!
									<Tooltip
										target={`.${id}`}
										at={`.${id}`}
										autoHide={false}
										position="top"
										className="controls-tooltip"
										appendTo={this.controlRef.current}
									>
										<span>{extra.tooltip}</span>
									</Tooltip>
								)}

								<span className={id} ref={this.controlRef}>
									{parse(sanitizeHtml(this.tr(title), {
										allowedTags: false,
										allowedAttributes: false
									}))}
								</span>
							</div>
						)}
					</label>
				</div>
				<div className="col-xs-12">{this.props.children}</div>
			</div>
		);
	}
}

export default Field;
